import { Pipe, PipeTransform } from '@angular/core';
import { ServiceordreKildeEnumDto } from '../api/models/OK/Egis/Service/Models/DTO/Enums/serviceordre-kilde-enum-dto';
@Pipe({
    name: 'serviceordreKilde',
    standalone: false
})
export class ServiceordreKildePipe implements PipeTransform {
  transform(value: ServiceordreKildeEnumDto) {
    switch (value) {
      case ServiceordreKildeEnumDto.Egis:
        return 'EGIS';
      case ServiceordreKildeEnumDto.G4S:
        return 'G4S';
      case ServiceordreKildeEnumDto.PartnerOprettet:
        return 'Partner oprettet';
      case ServiceordreKildeEnumDto.KonverteretEftersyn:
        return 'Konverteret eftersyn';
      case ServiceordreKildeEnumDto.Valeur:
        return 'Valeur';
    }
    return value;
  }
}
